var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransporter = function SvgTransporter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88 1H2.866v2.601H1.293v2.67h1.574v6.162c.356 1.862 2.293 2.373 3.218 2.396l2.053-.069v-2.327c-.262.023-.93.055-1.506 0-.575-.055-.741-.594-.753-.856V6.1h2.122V3.5H5.88V1ZM12.563 13.288a1.274 1.274 0 1 1-2.548 0 1.274 1.274 0 0 1 2.548 0Z",
    fill: "#07A658",
    stroke: "#07A658",
    strokeWidth: 0.875
  })));
};
export default SvgTransporter;